class Tracking {
  constructor() {
    this.attachAttributes();
    this.attachEvents();
  }

  attachAttributes() {
    const $headerNavButtons = document.querySelectorAll('#header-nav a');
    const $submenus = document.querySelectorAll('#header-nav .sub-menu a');
    const $institutionalButtons = document.querySelectorAll(
      '#header-nav #menu-item-379 .sub-menu a'
    );

    if ($headerNavButtons.length) {
      $headerNavButtons.forEach(($btn) => {
        $btn.setAttribute('data-tracking', 'header-nav');
      });
    }

    if ($submenus.length) {
      $submenus.forEach(($btn) => {
        $btn.setAttribute('data-tracking', 'header-nav-sub-menu');
        $btn.setAttribute(
          'data-tracking-data',
          '{"menu-itens": "' + $btn.textContent + '"}'
        );
      });
    }

    if ($institutionalButtons.length) {
      $institutionalButtons.forEach(($btn) => {
        $btn.setAttribute(
          'data-tracking-data',
          '{"menu-itens": "' + $btn.textContent + '"}'
        );
      });
    }
  }

  attachEvents() {
    this.$buttons = document.querySelectorAll('[data-tracking]');

    if (this.$buttons.length) {
      this.$buttons.forEach(($btn) => {
        $btn.removeEventListener('click', this.handleClick);
        $btn.addEventListener('click', this.handleClick);
      });
    }
  }

  handleClick(event) {
    if (!dataLayer) return;

    const $btn = event.currentTarget;
    const eventTracking = $btn.getAttribute('data-tracking');
    const eventCategory = $btn.getAttribute('data-tracking-category');
    const eventData = $btn.getAttribute('data-tracking-data');
    const formattedEventData = eventData ? JSON.parse(eventData) : {};

    const params = {
      event: eventTracking,
      ...formattedEventData,
    };

    if (eventCategory) {
      params.event_category = eventCategory;
    }

    dataLayer.push(params);
  }
}

new Tracking();
